import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("settings", ["equipmentType"])
  },
  data() {
    return {
      variables: []
    };
  },
  created() {
    this.bindEquipmentType(this.equipmentProfile?.equipmentType);
  },
  methods: {
    bindEquipmentType(equipmentType) {
      let id = equipmentType;

      let result = this.equipmentType?.filter(item => {
        return id === item.id;
      });
      this.variables = result[0].variables;
    }
  }
};
